<template>
  <el-main class="app-main" style="padding:0">
    <router-view></router-view>
    <div v-if="isShow" class="service">
      <div v-show="wechat || phone" class="service_window">
        <div v-show="phone">
          <div style="color:#0087FE;margin:11px 14px;">咨询电话：</div>
          <div style="margin:11px 14px;">{{ phone1 }}</div>
          <div style="color:#0087FE;margin:11px 14px;">客服电话：</div>
          <div style="margin:11px 14px;">{{ phone2 }}</div>
        </div>
        <div v-show="wechat" style="text-align:center;">
          <img
            :src="imgUrl"
            style="width:76px;height:76px;margin-top:5px;"
            alt=""
          />
          <div style="margin-top:8px;">扫码添加微信客服</div>
          <div style="margin-top:8px;">随时随地在线咨询</div>
        </div>
      </div>
      <div
        @mouseover="wechat = true"
        class="service_item"
        @mouseleave="wechat = false"
      >
        <i style="color:#29C98F;" class="icon-weixin"></i>
        <div>人工客服</div>
      </div>
      <div
        @mouseover="phone = true"
        class="service_item"
        @mouseleave="phone = false"
      >
        <i style="color:#008DFF;" class="icon-dianhuazixun"></i>
        <div>电话咨询</div>
      </div>
    </div>
  </el-main>
</template>
<script>
export default {
  name: "app-main",
  data() {
    return {
      isShow: false,
      wechat: false,
      phone: false,
      phone1: "",
      phone2: "",
      imgUrl: ""
    };
  },
  watch: {
    $route: function() {
      this.isShow = this.$route.path.indexOf("/device-management") !== -1;
    }
  },
  created() {
    this.getInfo();
    this.isShow = this.$route.path.indexOf("/device-management") !== -1;
  },
  methods: {
    getInfo() {
      this.$http
        .get(
          this.$api.getApiAddress(
            "operationplatformmgn/o/saas/customer-info/info",
            "API_ROOT"
          )
        )
        .then(res => {
          if (res.data != null) {
            this.phone1 = res.data.advisoryPhone;
            this.phone2 = res.data.custPhone;
            this.imgUrl = res.data.filePath;
          }
        });
    }
  }
};
</script>
<style lang="less">
.app-main {
  height: calc(~"100%");
  background: #f4f6f7;
  & > div {
    height: calc(~"100%");
  }
  .service {
    position: relative;
    width: 61px;
    height: 135px;
    z-index: 991;
    position: fixed;
    bottom: 50px;
    left: 30px;
    .service_window {
      position: absolute;
      top: 2px;
      color: #7c8494;
      right: -120px;
      width: 116px;
      height: 132px;
      background: rgba(255, 255, 255, 1);
      box-shadow: -1px 1px 10px 0px rgba(10, 62, 141, 0.18);
      border-radius: 2px;
    }
    .service_item {
      margin-top: 2px;
      position: relative;
      width: 61px;
      height: 65px;
      background: rgba(255, 255, 255, 1);
      box-shadow: -1px 1px 10px 0px rgba(10, 62, 141, 0.18);
      border-radius: 2px;
      color: #2e3640;
      cursor: pointer;
      i {
        position: absolute;
        left: 50%;
        top: 15px;
        transform: translateX(-50%);
      }
      div {
        width: 100%;
        text-align: center;
        position: absolute;
        top: 41px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/views/layout/app-main.vue